import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import './scss/index.scss';
import TopContent from './component/top-content';
import Color from '@/tool/color';
import { effectInit } from './store';
import URI from 'urijs';
// @ts-ignore
import QRcode from 'qrcodejs2';

import HumanResource from './human-resources';
import IndustryEffect from './support-effect/industry-effect/index';
import EffectTrend from './support-effect/effect-trend/index';
import SettleMultiIndustry from './stuff-settle/industry-compare/index';
import SettleTimeTrend from './stuff-settle/time-trend/index';
import SettleDistibutionRate from './stuff-settle/distribution-rate/index';
import SettleStuffTrend from './stuff-settle/stuff-trend/index';
import SalaryMultiIndustry from './salary-cost/industry-compare/index';
import SalaryTimeTrend from './salary-cost/time-trend/index';
import SalaryFeeRate from './salary-cost/fee-rate/index';
import '../effect-pdf/human-resources/scss/index.scss';
import BigTitle from './component/big-tltle';
import Service from '@/service';
import Cookies from 'js-cookie';
import moSkin, { skinInit } from '@/store/skin';
import moSkinPdf, { skinInitPdf } from '@/store/skinpdf';

interface IProps { }
interface IState { }

const Effect = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const uri = new URI(window.location.href);
  const path: any = uri.query(true);
  const result: any = decodeURIComponent(path.check);
  const data = JSON.parse(result);

  useEffect(() => {
    skinInitPdf(data.type);
    Cookies.set('access_token', data.token);
    const code = document.getElementById('myCode') || '';
    if (code) {
      Service.user().then((res: any) => {
        new QRcode(code, {
          render: 'canvas',
          text: `${data.difPath}/h5/register?invite_code=${res.promotion_code}`,
          width: 210,
          height: 210,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRcode.CorrectLevel.H,
        });
      });
    }
    setTimeout(() => {
      effectInit(data.tabList);
    }, 500);
  }, []);

  return (
    <section className="effect-pdf-page" id='effectcontentpdf'>
      <TopContent />
      {(data.tabList?.a1 || data.tabList?.a2 || data.tabList?.a3 || data.tabList?.a4 || data.tabList?.a5 || data.tabList?.a6 ||
        data.tabList?.b1 || data.tabList?.b2 || data.tabList?.b3 || data.tabList?.b4 || data.tabList?.b5 || data.tabList?.b6 ||
        data.tabList?.c1 || data.tabList?.c2 || data.tabList?.c3 ||
        data.tabList?.d1 || data.tabList?.d2 || data.tabList?.d3 || data.tabList?.d4 ||
        data.tabList?.e1 || data.tabList?.e2 ||
        data.tabList?.f1 || data.tabList?.f2 || data.tabList?.f3 || data.tabList?.f4 || data.tabList?.f5 || data.tabList?.f6 ||
        data.tabList?.g) && <BigTitle title="人力资源效能" />}
      <HumanResource />

      {/** 薪酬成本投入 */}
      <section className="box-5550">
        {(data.tabList?.h || data.tabList?.i || data.tabList?.j) ? (
          <BigTitle title="薪酬成本投入" />
        ) : null}
        {data.tabList?.h ? (
          <section className="lead-box_555">
            <SalaryMultiIndustry data={data.tabList} />
          </section>
        ) : null}
        {data.tabList?.i ? (
          <>
            {data.tabList?.h ? (
              <section className="pdf-items-warp">
                <SalaryTimeTrend data={data.tabList} />
              </section>
            ) : (
              <section className="lead-box_555">
                <SalaryTimeTrend data={data.tabList} />
              </section>
            )}
          </>
        ) : null}
        {data.tabList?.j ? (
          <>
            {(data.tabList?.h || data.tabList?.i) ? (
              <section className="pdf-items-warp">
                <SalaryFeeRate />
              </section>
            ) : (
              <section className="lead-box_555">
                <SalaryFeeRate />
              </section>
            )}
          </>
        ) : null}
      </section>

      {/** 人员配置 */}
      <section className="box-5550">
        {(data.tabList?.k || data.tabList?.l || data.tabList?.m || data.tabList?.n) ? (
          <BigTitle title="人员配置" />
        ) : null}
        {data.tabList?.k ? (
          <section className="lead-box_555">
            <SettleMultiIndustry data={data.tabList} />
          </section>
        ) : null}
        {data.tabList?.l ? (
          <>
            {data.tabList?.k ? (
              <section className="pdf-items-warp">
                <SettleTimeTrend />
              </section>
            ) : (
              <section className="lead-box_555">
                <SettleTimeTrend />
              </section>
            )}
          </>
        ) : null}
        {data.tabList?.m ? (
          <>
            {(data.tabList?.k || data.tabList?.l) ? (
              <section className="pdf-items-warp">
                <SettleDistibutionRate data={data.tabList} />
              </section>
            ) : (
              <section className="lead-box_555">
                <SettleDistibutionRate data={data.tabList} />
              </section>
            )}
          </>
        ) : null}
        {data.tabList?.n ? (
          <>
            {(data.tabList?.k || data.tabList?.l || data.tabList?.m) ? (
              <section className="pdf-items-warp">
                <SettleStuffTrend />
              </section>
            ) : (
              <section className="lead-box_555">
                <SettleStuffTrend />
              </section>
            )}
          </>
        ) : null}
      </section>

      {/** 支持效能 */}
      <section className="box-5550">
        {(data.tabList?.o || data.tabList?.p) ? <BigTitle title="支持效能" /> : null}
        {data.tabList?.o ? (
          <section className="lead-box_555">
            <IndustryEffect data={data.tabList} />
          </section>
        ) : null}
        {data.tabList?.p ? (
          <>
            {data.tabList?.o ? (
              <section className="pdf-items-warp">
                <EffectTrend />
              </section>
            ) : (
              <section className="lead-box_555">
                <EffectTrend />
              </section>
            )}
          </>
        ) : null}
      </section>

      <section className='effect-pdf-foot'>
        <section className='left'>
          <p>洞察外部数据</p>
          <i className='line'></i>
          <p>优化内部方案</p>
          <p>{moSkinPdf.partner === 'smartsalary' && '「薪智」'}人力资源大数据平台，为您呈现外部市场动态与趋势，助您提升内部人才管理策略和方案</p>
          <img src={moSkinPdf.logo2} alt="" className='logo-11' />
        </section>
        <section className='code' id="myCode" />
      </section>
    </section>
  );
};

export default observer(Effect);
